import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty, isEqual, map } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import { TableContainer } from '@mui/material';

import * as annotationOps from '../../../api/Annotations/annotation-operations';
import Loading from '../Loading';
import Annotations from '../../../api/Annotations/Annotations';
import ViewAnnotation from '../ViewAnnotation';
import VideoAnnotationsMaps from './VideoAnnotationsMaps';

import * as videoOps from '../../../api/Videos/video-operations';
import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';

import { GridContainer, Grid } from '../../atoms/AtlasAtoms/styles';

import AnnotationsMapsTable from './AnnotationsMapsTable';
import AnnotationMapsEditor from './AnnotationsMapsEditor/AnnotationMapsEditor';
import ImportAnnotationMaps from './ImportAnnotationMaps';

import useTimeStore from '../ZustandProvider';

class AnnotationsMaps extends Component {
  annotationDiv = React.createRef();

  tableElement = React.createRef();

  StyledTextField = {
    color: 'white'
  };

  state = {
    count: 0,
    isEditor: false,
    isImport: false,
    methodImport: 'none',
    isUpdateEditor: false,
    fileJson: {},
    fileName: '',
    selectedAnnotation: {},
    sizePlayer: { x: 0, y: 0, width: 0, height: 0 },
    timeVideoDuration: 0,
    getNewAnnotationId: '',
    annotationDeleted: {},
    annotationUpdated: {},
    isManyDelete: false,
    annotationsImport: true
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      annotations,
      coordinatesAnnotations,
      videoSelected,
      prevVideoSelect,
      handlePrevVideoSelected,
      loading
    } = this.props;
    const {
      getNewAnnotationId,
      annotationDeleted,
      annotationUpdated,
      isManyDelete,
      annotationsImport
    } = this.state;
    const {
      annotations: prevAnnotations,
      coordinatesAnnotations: prevCoordsAnnotations
    } = prevProps;
    const {
      getNewAnnotationId: prevNewAnnotationId,
      annotationDeleted: prevAnnotationDeleted,
      annotationUpdated: prevAnnotationUpdated
    } = prevState;

    if (!isEmpty(annotations)) {
      this.handleAllAnnotations(annotations);
    } else {
      this.handleAllAnnotations({});
    }
    if (!isEmpty(videoSelected)) {
      const isVideoLine = videoSelected.coordinatesDataType !== VIDEO_COORDINATE_DATA_TYPES.POINT;
      if (!isVideoLine) {
        const coordsLatLng0 = videoSelected.latLng0;
        const lat = coordsLatLng0[1];
        const lng = coordsLatLng0[0];
        this.handleSelectTrackAndPointCoords([], { lat, lng });
      } else {
        const videoTrack = videoOps.getTrack(videoSelected);
        const { coordinates } = videoTrack.geometry;
        const coordsTrack = coordinates;
        this.handleSelectTrackAndPointCoords(coordsTrack, {});
      }
    }

    if (
      !isEqual(videoSelected, prevVideoSelect) &&
      !isEqual(annotations, prevAnnotations) &&
      !loading
    ) {
      const annotationVideoId = !isEmpty(annotations) ? annotationOps.getVideo(annotations[0]) : '';
      const videoId = videoOps.getId(videoSelected);
      const prevVideoId = videoOps.getId(prevVideoSelect);
      if (isEqual(annotationVideoId, videoId) && !isEqual(annotationVideoId, prevVideoId)) {
        if (!isEmpty(annotations)) {
          this.handleSelectAnnotation(annotations[0], 0);
          handlePrevVideoSelected(videoSelected);
        } else {
          this.handleSelectAnnotation({}, 0);
        }
      } else {
        this.handleSelectAnnotation({}, 0);
      }
    }
    if (!isEmpty(annotations) && annotationsImport) {
      this.handleSelectAnnotation(annotations[0], 0);
    }

    if (!isEqual(annotationDeleted, prevAnnotationDeleted)) {
      if (!isEmpty(annotationDeleted)) {
        let newCount = 0;
        const idDeleted = annotationOps.getId(annotationDeleted);
        map(prevAnnotations, (element, index) => {
          const idAnnotation = annotationOps.getId(element);
          if (idAnnotation === idDeleted) {
            newCount = index;
          }
        });
        if (newCount === 0) this.handleSelectAnnotation(annotations[newCount], newCount);
        else this.handleSelectAnnotation(annotations[newCount - 1], newCount - 1);
      }
    }

    if (isManyDelete) {
      this.handleSelectAnnotation({}, 0);
      this.handleManyDeleteAnnotations(false);
    }

    if (!isEqual(getNewAnnotationId, prevNewAnnotationId)) {
      let newCount = 0;
      let newAnnotation = {};
      map(annotations, (element, index) => {
        const idAnnotation = annotationOps.getId(element);
        if (idAnnotation === getNewAnnotationId) {
          newCount = index;
          newAnnotation = element;
        }
      });
      this.handleSelectAnnotation(newAnnotation, newCount);
    }

    if (!isEqual(annotationUpdated, prevAnnotationUpdated)) {
      let newCount = 0;
      const updatedId = annotationOps.getId(annotationUpdated);
      map(annotations, (element, index) => {
        const idAnnotation = annotationOps.getId(element);
        if (idAnnotation === updatedId) {
          newCount = index;
        }
      });
      this.handleSelectAnnotation(annotationUpdated, newCount);
    }

    if (!isEqual(coordinatesAnnotations, prevCoordsAnnotations)) {
      let newCount = 0;
      const newId = annotationOps.getId(coordinatesAnnotations);
      map(annotations, (element, index) => {
        const idAnnotation = annotationOps.getId(element);
        if (idAnnotation === newId) {
          newCount = index;
        }
      });
      this.handleSelectAnnotation(coordinatesAnnotations, newCount);
    }
  }

  changeStateProperty = (property, value) => this.setState({ [property]: value });

  handleAnnotationDeleted = annotationDeleted => {
    this.setState({ annotationDeleted });
  };

  handleAnnotationUpdated = annotationUpdated => {
    this.setState({ annotationUpdated });
  };

  handleCloseEdit = () => {
    this.setState({ isEditor: false });
    useTimeStore.setState({ isNotesVideoEditor: 'close' });
  };

  handleCloseImport = annotationsImportlength => {
    const isImportAnnotations = annotationsImportlength > 0;
    this.setState({ isImport: false, annotationsImport: isImportAnnotations });
    useTimeStore.setState({ isNotesVideoEditor: 'close' });
  };

  handleCloseUpdateEditor = () => {
    this.setState({ isUpdateEditor: false, isEditor: false });
  };

  handleDurationVideo = time => {
    this.setState({ timeVideoDuration: time });
  };

  handleNewAnnotationId = annotationId => {
    this.setState({ getNewAnnotationId: annotationId });
  };

  handleAllAnnotations = annotationsProp => {
    useTimeStore.setState({
      allCoordsAnnotations: annotationsProp
    });
  };

  handleSelectAnnotation = (annotation, countProp) => {
    this.setState({
      selectedAnnotation: annotation,
      count: countProp,
      annotationsImport: false
    });
    useTimeStore.setState({
      coordinatesAnnotations: annotation
    });
  };

  handleSelectTrackAndPointCoords = (coordinatesTrackVideoProp, coordinatesVideoPointProp) => {
    useTimeStore.setState({
      coordinatesTrackVideo: coordinatesTrackVideoProp,
      coordinatesVideoPoint: coordinatesVideoPointProp
    });
  };

  handleSelectedTemplate = template => {
    this.setState({ selectedTemplate: template });
  };

  handleCreateAnnotation = () => {
    useTimeStore.setState({ checkCenterAnnotation: true });
    this.setState({ isEditor: true });
  };

  handleImportAnnotation = (event, method) => {
    const filePath = event.target.value;
    const pathArrayFile = filePath.split('\\');
    const nameFileWithExtension = pathArrayFile[pathArrayFile.length - 1];
    const nameFileArray = nameFileWithExtension.split('.');
    const nameFile = nameFileArray[0];

    const file = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = async () => {
      const { result } = fileReader;
      const parsedText = JSON.parse(result);
      const fileImport = parsedText[0];
      const annotationImport = isEmpty(fileImport) ? parsedText : fileImport;
      this.setState({
        isImport: true,
        fileName: nameFile,
        fileJson: annotationImport,
        methodImport: method
      });
      useTimeStore.setState({ checkCenterAnnotation: true });
    };
    fileReader.onerror = () => {
      Bert.alert('Error on load file', 'danger');
    };
  };

  handleManyDeleteAnnotations = isDelete => {
    this.setState({ isManyDelete: isDelete });
  };

  handleSizeVideo = (widthPlayer, heightPlayer) => {
    const positionX = widthPlayer / 2;
    const positionY = heightPlayer / 2;
    this.setState({
      sizePlayer: { x: positionX, y: positionY, width: widthPlayer, height: heightPlayer }
    });
  };

  handleTimeVideo = time => {
    const { totalCountAnnotations, annotations } = this.props;
    for (let i = 0; i < totalCountAnnotations; i += 1) {
      if (Math.round(time) === Math.round(annotationOps.getVideoTime(annotations[i]) * 1e-6)) {
        this.setState({ selectedAnnotation: annotations[i] });
        this.setState({ count: i });
        useTimeStore.setState({ coordinatesAnnotations: annotations[i] });
        break;
      }
    }
  };

  handleUpdateAnnotation = () => {
    this.setState({ isUpdateEditor: true, isEditor: true });
  };

  render() {
    const { annotations, gridBackgroundColor, loading, notesProps, videoSelected } = this.props;
    const annotationTemplates = videoOps.getAnnotationTemplates(videoSelected);
    const { isEditor, isImport, selectedAnnotation } = this.state;

    if (loading) return <Loading />;
    return (
      <>
        {isImport && (
          <ImportAnnotationMaps
            {...this.props}
            {...this.state}
            annotationsProp={annotations}
            handleCloseImport={this.handleCloseImport}
          />
        )}
        {isEditor && (
          <AnnotationMapsEditor
            {...this.props}
            {...this.state}
            annotationTemplates={annotationTemplates}
            handleCloseEdit={this.handleCloseEdit}
            handleCloseUpdateEditor={this.handleCloseUpdateEditor}
            handleNewAnnotationId={this.handleNewAnnotationId}
            handleAnnotationDeleted={this.handleAnnotationDeleted}
            handleAnnotationUpdated={this.handleAnnotationUpdated}
          />
        )}
        {!isEditor && !isImport && (
          <>
            <AnnotationsMapsTable
              {...this.props}
              {...this.state}
              handleSelectAnnotation={this.handleSelectAnnotation}
              handleCreateAnnotation={this.handleCreateAnnotation}
              handleImportAnnotation={this.handleImportAnnotation}
              handleManyDeleteAnnotations={this.handleManyDeleteAnnotations}
              handleUpdateAnnotation={this.handleUpdateAnnotation}
            />
            <GridContainer backgroundcolor={gridBackgroundColor} fullScreen>
              <Grid xs={12} md={12}>
                <TableContainer sx={{ overflowX: 'hidden' }} size="lg" height="100%">
                  {!isEmpty(annotations) && (
                    <ViewAnnotation
                      annotation={selectedAnnotation}
                      changeVideoContainerStateProperty={this.changeStateProperty}
                      isPublic
                      {...this.props}
                      {...this.state}
                    />
                  )}
                  {notesProps.showVideo && !isEmpty(videoSelected) && (
                    <>
                      <VideoAnnotationsMaps
                        handleDurationVideo={this.handleDurationVideo}
                        handleSizeVideo={this.handleSizeVideo}
                        handleTimeVideo={this.handleTimeVideo}
                        handleSelectAnnotation={this.handleSelectAnnotation}
                        {...this.props}
                        {...this.state}
                      />
                    </>
                  )}
                </TableContainer>
              </Grid>
            </GridContainer>
          </>
        )}
      </>
    );
  }
}

AnnotationsMaps.defaultProps = {
  annotations: [],
  checkCenterAnnotation: false,
  coordinatesAnnotations: {},
  countTotalVideo: 0,
  gridBackgroundColor: '#98c1de',
  isMobile: false,
  isNotesComponent: true,
  notesProps: {},
  totalCountAnnotations: 0,
  totalVideo: 0,
  videoSelected: {},
  prevVideoSelect: {}
};

AnnotationsMaps.propTypes = {
  annotations: PropTypes.array,
  checkCenterAnnotation: PropTypes.bool,
  coordinatesAnnotations: PropTypes.object,
  countTotalVideo: PropTypes.number,
  gridBackgroundColor: PropTypes.string,
  handleChangeVideos: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  isNotesComponent: PropTypes.bool,
  listVideosObjects: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  notesProps: PropTypes.object,
  totalCountAnnotations: PropTypes.number,
  totalVideo: PropTypes.number,
  videoSelected: PropTypes.object,
  prevVideoSelect: PropTypes.object,
  handlePrevVideoSelected: PropTypes.func.isRequired
};

export default withTracker(({ videoSelected }) => {
  let annotationSub = {};
  let annotations = [];
  let totalCountAnnotations = 0;
  const video = videoOps.getId(videoSelected);

  if (!isEmpty(video)) {
    annotationSub = Meteor.isClient && Meteor.subscribe('annotations.video', video);
    annotations = Annotations.find({}, { sort: { videoTime: 1 } }).fetch();
    annotations.sort((a, b) => a.geoJSON.properties.videoTime - b.geoJSON.properties.videoTime);
    totalCountAnnotations = Annotations.find({}, { sort: { videoTime: 1 } }).count();
  }
  return {
    annotations,
    loading: !isEmpty(video) && !annotationSub.ready(),
    totalCountAnnotations
  };
})(AnnotationsMaps);
